export default __webpack_public_path__ + "static/media/Furniture.0c1a7abc.png";